import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from '../../../home/redux/actions';
import * as myAccountActions from '../../../my-account/redux/actions';
import * as serviceActions from '../../../pb-service-list/redux/actions';

import { KuposDatePicker, KuposSelectBox } from '../../../common';
import React, { useState } from 'react';

import DateService from '../../../../services/dateService';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import i18next from 'i18next';
import { useRef } from 'react';
import { withTranslation } from 'react-i18next';

const ConfirmCouponInputVertical = props => {
  console.log('ConfirmCouponInputVertical', props);

  const { t, home, actions, history, operator } = props.data;
  const errorInitialState = {
    source: '',
    destination: '',
    date: '',
  };
  const [error, setError] = useState(errorInitialState);
  const destinationRef = useRef({});

  const onSourceChange = value => {
    setError({ ...error, source: null });
    actions.pbSetSourceCity(value);
    getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity);

    if (home.pbDestinationCity && value.value === home.pbDestinationCity.value) {
      onDestinationChange(null);
    }

    destinationRef.current.onMenuOpen();
    destinationRef.current.select.focus();
  };

  const onDestinationChange = value => {
    setError({ ...error, destination: null });
    actions.pbSetDestinationCity(value);
  };

  const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
    if (rawArray && itemToRemove) {
      return rawArray
        .map(obj => {
          if (obj.label == itemToRemove.label) {
          } else {
            return obj;
          }
        })
        .filter(function(obj) {
          return typeof obj !== 'undefined';
        });
    } else if (!itemToRemove) {
      // return rawArray;
    }
  };

  const search = e => {
    e.preventDefault();
    if (!props.common.loginData) {
      props.actions.openCloseLoginModal(true);
      return;
    }
    if (!home.pbSourceCity) {
      setError({ ...error, source: 'VALIDATIONS.VALID_ORIGIN_CITY' });
      return;
    } else if (!home.pbDestinationCity) {
      setError({ ...error, destination: 'VALIDATIONS.VALID_DESTINATION_CITY' });
      return;
    } else {
      let source = home.pbSourceCity.label
        .toLowerCase()
        .replace(/-/g, '_')
        .replace(/ /g, '-')
        .replace(/_/g, '--');
      let dest = home.pbDestinationCity.label
        .toLowerCase()
        .replace(/-/g, '_')
        .replace(/ /g, '-')
        .replace(/_/g, '--');
      actions.setServiceListOnward(null);
      if (!home.returnPBDate) {
        history.push(
          `/${i18next.language}/${
            i18next.language == 'es' ? 'pasajes-bus' : 'bus-tickets'
          }/${source}/${dest}/${
            home.onwardPBDate ? home.onwardPBDate : DateService.getTodayString()
          }?is_mot=true`,
        );
      } else {
        history.push(
          `/${i18next.language}/${
            i18next.language == 'es' ? 'pasajes-bus' : 'bus-tickets'
          }/${source}/${dest}/${home.onwardPBDate}/${home.returnPBDate}/1`,
        );
      }
    }
  };

  // console.log(props);

  return (
    <form onSubmit={search}>
      <div className="home-selection-input-boxes" style={{ display: 'block' }}>
        <div className="home-selection-input-box font10">
          <span className="label font11">{t('HOME.ORIGIN')}</span>
          <KuposSelectBox
            reactSelect
            selectType="origin"
            options={home.uniqueCities ? home.uniqueCities : []}
            selectedOption={home.pbSourceCity}
            onChange={onSourceChange}
            // onInputChange={this.onInputChange}
            // placeholder={'Source'}
            icon={getIcons('Origin', operator)}
            hideArrow={true}
            error={error.source ? true : false}
            errorMessage={t(error.source)}
            placeholder={t('HOME.ORIGIN')}
            height={40}
            t={t}
          />
        </div>

        <div className="home-selection-input-box font10">
          <span className="label font11">{t('HOME.DESTINATION')}</span>
          <KuposSelectBox
            reactSelect
            selectType="destination"
            selectRef={destinationRef}
            options={
              home.pbSourceCity
                ? getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity)
                : []
            }
            selectedOption={home.pbDestinationCity}
            onChange={onDestinationChange}
            // onInputChange={this.onInputChange2}
            // placeholder={'Destination'}
            icon={getIcons('Destination', operator)}
            hideArrow={true}
            error={error.destination ? true : false}
            errorMessage={t(error.destination)}
            placeholder={t('HOME.DESTINATION')}
            height={40}
            t={t}
          />
        </div>

        <div className="home-selection-input-box font10 datebox">
          <span className="label font11">{t('HOME.ONE_WAY')}</span>
          <KuposDatePicker
            selectedDate={home.onwardPBDate ? home.onwardPBDate : DateService.getTodayString()}
            onDateChange={date => {
              actions.setOnwardPbDate(date);
              date > home.returnPBDate ? actions.setReturnPbDate(date) : null;
            }}
            minDate={DateService.getTodayString()}
            error={error.date ? true : false}
            errorMessage={error.date}
            placeholder={t('HOME.SELECT_DATE')}
            t={t}
          />
        </div>

        <div className="home-selection-input-box font12 datebox">
          <button
            style={{
              background:
                operator && operator.color_codes && operator.color_codes.button_color
                  ? operator.color_codes.button_color
                  : '',
              borderRadius: '20px',
            }}
            className="kupos-button home-selection-input-button less-bold-text "
            // onClick={search}
            type="submit"
          >
            <img src={getIcons('Search', operator)} alt="" style={{ height: 25 }} />
            <span>{t('HOME.SEARCH')}</span>
          </button>
        </div>
      </div>
    </form>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...actions,
        ...serviceActions,
        ...myAccountActions,
        ...commonActions,
        ...homeActions,
      },
      dispatch,
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(ConfirmCouponInputVertical));



// WEBPACK FOOTER //
// ./src/features/themes/common/search-box/ConfirmCouponInputVertical.js